import React from 'react';
export function FooterSection() {
  return <footer className="bg-black text-white/60 py-10 text-center text-sm px-4 border-t border-brand-border" data-id="element-101">
      <p className="font-medium tracking-wide" data-id="element-102">
        © 2026 ICE HOCKEY READY — All Rights Reserved.
      </p>
    </footer>;
}